module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.show,
      "custom-class": 'spr-dialog ' + _vm.name,
      "size": _vm.size
    },
    on: {
      "update:visible": function (flag) { return this$1.$emit('update:show', flag); },
      "open": function () { return this$1.$emit('open'); }
    }
  }, [_c('span', {
    staticClass: "title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function () { return this$1.$emit('confirm'); }
    }
  }, [_vm._v("确定")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e2b4c1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage/Dialog.vue
// module id = 759
// module chunks = 0